import { PAGE_CHANNEL, PAGE_MAIN, PAGE_PLAYER, PAGE_SEARCH } from '@/modules/common/constants/pages';

export const SEARCH_PATH = '/search';
export const SEARCH_VIEW_PATH = '/search/:video';
export const SHARE_VIEW_PATH = '/videos/:video';
export const SINGLE_VIEW_PATH = '/video/:video';
export const SEARCH_AI_VIEW_PATH = '/genai/:video';
export const CHANNEL_VIEW_PATH = '/channel/:channel';
export const DEFAULT_VIEW_PATH = '/channel/:channel/:video';
export const CHANNEL_LIST_PATH = '/';

export const TT_EDITORIAL = '/studio';

export const ALL_EXISTING_ROUTES = [
  CHANNEL_LIST_PATH,
  CHANNEL_VIEW_PATH,
  DEFAULT_VIEW_PATH,
  SEARCH_PATH,
  SEARCH_VIEW_PATH,
  SHARE_VIEW_PATH,
  SINGLE_VIEW_PATH,
  SEARCH_AI_VIEW_PATH,
];

export const ALL_PLAYER_PAGE_ROUTES = [
  SINGLE_VIEW_PATH,
  DEFAULT_VIEW_PATH,
  SEARCH_VIEW_PATH,
  SHARE_VIEW_PATH,
  SEARCH_AI_VIEW_PATH,
];

export const PAGE_TO_ROUTE_TAGS_MAPPER = {
  [PAGE_MAIN]: [CHANNEL_LIST_PATH],
  [PAGE_CHANNEL]: [CHANNEL_VIEW_PATH],
  [PAGE_PLAYER]: [DEFAULT_VIEW_PATH, SHARE_VIEW_PATH, SINGLE_VIEW_PATH, SEARCH_AI_VIEW_PATH],
  [PAGE_SEARCH]: [SEARCH_PATH, SEARCH_VIEW_PATH],
};
